import { AxiosResponse } from 'axios';
import api from '../../../services/api';
import { ensureSelectData } from '../select-pagination/select-pagination-service';
import clientService from '../client/client-service';
import domainService from '~/services/modules/domain/domain-service';

class mandatoryMixService {
  getAll() {
    return api.get('/sales-restriction/required-mix');
  }
  getMandatoryMix(id: any) {
    return api.get(`/sales-restriction/required-mix/${id}`);
  }
  deleteMandatoryMix(id: any) {
    return api.delete(`/sales-restriction/required-mix/${id}`);
  }
  createMandatoryMix(payload: any): Promise<AxiosResponse<any | null>> {
    return api.post('/sales-restriction/required-mix', payload);
  }
  editMandatoryMix(payload: any): Promise<AxiosResponse<any | null>> {
    return api.put('/sales-restriction/required-mix', payload);
  }
}

export function* ensureInputs(data: any, currentSelects: any, userExternalCode: string) {
  return yield* ensureSelectData([
    {
      key: 'clients',
      externalCodes: data?.clientsExternalCode || [],
      currentItems: currentSelects?.clientsExternalCode || [],
      service: (_, __, missingCodes) =>
        clientService.getQuery({
          skip: 0,
          limit: 0,
          fields: ['externalCode', 'name'],
          userExternalCode: userExternalCode,
          clientExternalCodes: missingCodes.join(',')
        })
    },
    {
      key: 'subsidiaries',
      externalCodes: data?.subsidiariesExternalCode || [],
      currentItems: currentSelects?.subsidiariesExternalCode || [],
      service: domainService.getSubsidiaries.bind(domainService)
    },
    {
      key: 'clientGroups',
      externalCodes: data?.clientsGroupExternalCode || [],
      currentItems: currentSelects?.clientGroup || [],
      service: domainService.getClientGroups.bind(domainService)
    }
  ]);
}

export default new mandatoryMixService();
